import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import light from '../../../assets/style/themes/dark';
import { sendRecoverPasswordEmail } from '../../../stores/actions/recoverPassword';
import EmailFormCard from './CardContent/emailFormCard';

// Mensagens de erro
const errEmailNotRegistered = 'Não existe usuário com o e-mail cadastrado';
const errFailOnRequest = 'Houve uma falha na requisição ou no servidor';
const internalServerError = 'Erro interno do servidor';

function RecoverPasswordRequest({ dispatch, running, error, location, emailSent }) {

  // error effect
  useEffect(() => {
    if (error) {
      const errResp = error.response;
      if (errResp.status === 404) {
        toast.error(errEmailNotRegistered);
      } else if (errResp.data.errors) {
        const serverErrorsMessage = errResp.data.errors.reduce((accumulator, currentValue) => `${accumulator}<br/>${currentValue.toString()}`);
        toast.error(serverErrorsMessage);
      } else if (errResp.status > 500) {
        toast.error(errFailOnRequest);
      } else if (errResp.data.errors) {
        const serverErrorsMessage = errResp.data.errors.reduce((accumulator, currentValue) => `${accumulator}<br/>${currentValue.toString()}`);
        toast.error(serverErrorsMessage);
      } else if (errResp.status === 500) {
        toast.error(internalServerError);
      }
    }
  }, [error]);

  /*
    função que chama o action para envio do email de recuperação de senha
    @params(email) endereço email do usuário
  */
  function handleSubmit(formEmail) {
    sendRecoverPasswordEmail(formEmail, dispatch);
  }
  /*
    Renderiza o conteúdo de acordo com o estado do emailSent caso o email tenha sido enviado retornar
    o componente de sucesso
  */

  return (
    <EmailFormCard 
      running={running} 
      handleSubmit={handleSubmit} 
      emailSent={emailSent} 
    />
  );
}
const mapStateToProps = (state) => {
  const recoverPasswordState = state.recoverPassword;

  return {
    running: recoverPasswordState.running,
    error: recoverPasswordState.error,
    emailSent: recoverPasswordState.emailSent,
  };
};
export default connect(mapStateToProps)(RecoverPasswordRequest);
